import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/webpractik/web/prod.webpractik.ru.w6p.ru/releases/172/components/features/cases/OldComponents/cases/frtService/index.tsx");
